interface Frequency {
  id: string;
  label: string;
  description: string;
  multiplier: number;
}

interface FrequencySelectorProps {
  frequencies: Frequency[];
  selectedFrequency: string;
  onSelect: (frequencyId: string) => void;
}

export default function FrequencySelector({ frequencies, selectedFrequency, onSelect }: FrequencySelectorProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {frequencies.map((freq) => (
        <button
          key={freq.id}
          onClick={() => onSelect(freq.id)}
          className={`p-4 rounded-lg border-2 transition-all duration-300 text-left ${
            selectedFrequency === freq.id
              ? 'border-primary bg-primary/5 shadow-md'
              : 'border-border hover:border-primary/50 hover:shadow-sm'
          }`}
        >
          <div className="flex items-center justify-between mb-2">
            <h4 className={`text-base font-heading font-semibold ${
              selectedFrequency === freq.id ? 'text-primary' : 'text-foreground'
            }`}>
              {freq.label}
            </h4>
            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
              selectedFrequency === freq.id
                ? 'border-primary bg-primary' :'border-border'
            }`}>
              {selectedFrequency === freq.id && (
                <svg className="w-3 h-3 text-primary-foreground" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </div>
          </div>
          <p className="text-sm text-muted-foreground">{freq.description}</p>
        </button>
      ))}
    </div>
  );
}